import { styled } from '@olxeu-jobs/ui';

export const Wrapper = styled('aside', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.space[16],
  padding: $theme.space[16],
  backgroundColor: $theme.colors['background-global-primary'],
  borderRadius: $theme.radii[4],
  ':empty': {
    display: 'none',
  },
}));
